(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('userRolesFilter', ['$filter', '$rootScope', 'UserRole', 'RoleType', 'UserBroadcast', 'UserFilterService', 'UserSearchPaginationService', UserRolesFilterFn]);

    // filter directive for user view
    function UserRolesFilterFn($filter, $rootScope, UserRole, RoleType, UserBroadcast, UserFilterService, UserSearchPaginationService) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/users/templates/user-roles-filter.template.html',
            scope: {
                rolesForUser: '='                
            }
        };
        return directive;

        function link(scope) {

            // number of set filter
            scope.numFilters = 0;
            // array with filter
            scope.roleTypes = [];

            //activate directive
            activate();

            // filter list
            scope.filter = function ($event, role) { 

                $event.stopPropagation();

                //reset
                scope.numFilters = 0;

                // role change
                if (role !== null) {
                    role.vmSelected = !role.vmSelected;
                }

                // back to localstorage
                updateFilterStates();
                // refresh view
                refresh();
                // calculate view
                calculate();
            };

            // listen
            function listen() {

                //check for doing a calculation
                var listenerCal = scope.$on(UserBroadcast.FilterCalculate, function () {
                    calculate();
                });

                // on destroy
                scope.$on("$destroy", function () {
                    listenerCal();
                    listenerCal = null;
                });
            } // listen


            // update filter states in local storage
            function updateFilterStates() {
                // reset
                var arr = [];

                // add states to array and localstorage
                for (var i = 0; i < scope.roleTypes.length; i++) {
                    if (scope.roleTypes[i].vmSelected) {
                        arr.push(scope.roleTypes[i]);
                    } //if
                } //for
                // set to local storage
                UserFilterService.saveRoleFilter(arr);
            } // updateFilterStates

            // refresh view
            function refresh() {
                updateFilterStates();

                // set selected roles       
                UserSearchPaginationService.data.pagination.roles = UserFilterService.loadRoleFilter().map(function (item) { return item.value; });

                // refresh overview
                UserSearchPaginationService.search();
                
                setNumberOfSelectedRoles();
            }

            function setNumberOfSelectedRoles() {
                scope.numFilters = 0;
                for (var i = 0; i < scope.roleTypes.length; i++) {
                    if (!scope.roleTypes[i].vmIsReadonlyForCurrentUser && scope.roleTypes[i].vmSelected) {
                        scope.numFilters++;
                    }
                }
            }

            // calc numbers of users with roletypes
            function calculate() {
                var i = 0;
                var len = scope.roleTypes.length;
                var rLen = UserSearchPaginationService.data.roleCounts.length;
                var r = 0;
                //reset badge numbers
                for (i; i < len; i++) {
                    scope.roleTypes[i].vmNumber = 0; // default clear
                    // find in result-role-counts
                    r = 0;
                    for (r; r < rLen; r++) {
                        if (UserSearchPaginationService.data.roleCounts[r].filter === scope.roleTypes[i].value + '') { // i got string
                            scope.roleTypes[i].vmNumber = UserSearchPaginationService.data.roleCounts[r].count;
                            break;
                        }
                    } // for
                } // for                
            } // calculate



            // init work
            function activate() {
                // are there any saved values in local-storage ? if not -> set default
                var ls = UserFilterService.loadRoleFilter();
                if (typeof ls === 'undefined' || ls === null) {
                    // set default
                    ls = [];

                    // if ringfoon admin -> main-user
                    if ($rootScope.isRingfoonAdmin) {
                        var mainUserRole = new UserRole(RoleType.MainUser);
                        ls.push(mainUserRole);
                    } //if
                    else {
                        // patient and representative
                        var patientRole = new UserRole(RoleType.Patient);
                        var representativeRole = new UserRole(RoleType.Representative);

                        ls.push(patientRole);
                        ls.push(representativeRole);
                    } // else
                } // if

                // generate filter array
                angular.forEach(RoleType, function (item) {
                    // it's not allowed to create/edit ringfoon admin
                    // new object
                    var role = new UserRole(item);
                    // set readonly state for current user
                    for (var i = 0; i < scope.rolesForUser.length; i++) {
                        if (item.value === scope.rolesForUser[i].type) {
                            role.vmIsReadonlyForCurrentUser = scope.rolesForUser[i].isReadonlyForCurrentUser;
                            break;
                        } // if
                    }//for
                    scope.roleTypes.push(role);
                });
                // calculate badge count
                calculate();
                // preselect roles from localstorage
                preselect(ls);
                setNumberOfSelectedRoles();
                // listen on events
                listen();
            } //activate

            // preselect filter from loc.storage
            function preselect(ls) {
                // iterator over local-storage-array
                for (var i = 0; i < ls.length; i++) {
                    var role = $filter('filter')(scope.roleTypes, { 'value': ls[i].value }, false)[0];
                    if (role && !role.vmIsReadonlyForCurrentUser) {
                        role.vmSelected = true;
                    } // if
                } //for
            } // preselect
        } // link
    }
})();